import {useEffect, useState} from 'react';
import blogDao from '../../dao/blogDao';

export default function useDeadLinkLists() {
  const [loading, setLoading] = useState(true);
  const [deadLinkLists, setDeadLinkLists] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const domains = await blogDao.listDeadLinkBlackLists();
        setDeadLinkLists(domains);
      } catch (err) {
        console.error('Failed to fetch dead link lists', err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return {deadLinkLists, loading};
}
